import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { settingsAPI } from '../services/api'

const DEFAULT_SETTINGS = {
  appName: 'OCPP Emulator',
  browserTitle: 'OCPP Charging Station Emulator',
  liveChatEmbed: '',
  emailOtpEnabled: false
}

const AppSettingsContext = createContext(null)

export function AppSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS)

  const applySettings = useCallback((next) => {
    const merged = {
      ...DEFAULT_SETTINGS,
      ...next,
      appName: String(next?.appName || DEFAULT_SETTINGS.appName).trim() || DEFAULT_SETTINGS.appName,
      browserTitle: String(next?.browserTitle || DEFAULT_SETTINGS.browserTitle).trim() || DEFAULT_SETTINGS.browserTitle,
      liveChatEmbed: String(next?.liveChatEmbed || ''),
      emailOtpEnabled: Boolean(next?.emailOtpEnabled)
    }
    setSettings(merged)
    if (typeof document !== 'undefined') {
      document.title = merged.browserTitle
    }
    return merged
  }, [])

  const refresh = useCallback(async () => {
    try {
      const response = await settingsAPI.getPublic()
      applySettings(response.data)
    } catch {
      applySettings(DEFAULT_SETTINGS)
    }
  }, [applySettings])

  useEffect(() => {
    refresh()
  }, [refresh])

  return (
    <AppSettingsContext.Provider value={{ settings, refresh, applySettings }}>
      {children}
    </AppSettingsContext.Provider>
  )
}

export function useAppSettings() {
  const context = useContext(AppSettingsContext)
  if (!context) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider')
  }
  return context
}

export default AppSettingsContext
